/* globals Class, Hash, lp, jui, editor, eventTracker */
var _ = require('lodash');
var jQuery = require('jquery');
var url = require('url');

module.exports = Class.create(lp.editor.BuilderModal, lp.ModuleComponent, {
  type: 'lp-script',

  predefinedOptionalScripts: [
    {
      name: 'jQuery (1.4.2)',
      listId: 'jquery',
      index: 0,
      disabled: true,
      predefined: true,
      group: 'jquery',
      containerId: null,
      placement: 'head',
      description:
        '<p>jQuery is a JavaScript library that simplifies HTML document traversing, event handling, animating, and Ajax interactions.</p>',
      content: {
        type: null,
        html:
          '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js" type="text/javascript"></script>'
      }
    },
    {
      name: 'jQuery.Fancybox (1.3.4)',
      listId: 'fancybox',
      index: 1,
      predefined: true,
      containerId: null,
      requires: 'jQuery (1.4.2)',
      placement: 'head',
      description:
        '<p>FancyBox is a jQuery plugin for displaying and zooming images, web pages and multi-media in lightbox style windows.</p>',
      content: {
        type: null,
        html:
          '<link href="//assets.unbounce.com/m/lp-webapp/jquery.fancybox-1.3.4/fancybox/jquery.fancybox-1.3.4.css" media="screen" rel="stylesheet" type="text/css">\n' +
          '<script src="//assets.unbounce.com/m/lp-webapp/jquery.fancybox-1.3.4/fancybox/jquery.fancybox-1.3.4.js"></script>'
      }
    }
  ],

  initialize: function($super) {
    this.controls = {};
    this.currentScripts = [];
    this.newScripts = [];
    this.selectedScript = null;
    this.selectedPredefinedScript = null;
    this.undoGroupStarted = false;

    $super({
      actions: [
        {
          id: 'done',
          label: 'Done',
          class: 'save-code-button action',
          action: this.done.bind(this)
        },
        {
          id: 'cancel',
          class: 'push-left',
          label: 'Discard',
          action: this.close.bind(this)
        }
      ],
      closeX: true,
      attributes: {
        className: 'modal-panel scripts-panel'
      },
      layoutRules: {
        method: lp.editor.BuilderModal.fitToViewport,
        options: {
          padding: 12,
          size: { width: 1000, height: 600 }
        }
      }
    });
  },

  installUI: function($super) {
    /*jshint maxstatements:47*/
    $super();
    var updateView = this.updateView.bind(this);
    this.setTitle('Manage Scripts');
    var manager = this.contentPanel.insert(
      new jui.Component({
        attributes: {
          id: 'script-manager',
          className: 'scripts-manager'
        }
      })
    );

    var leftPanel = new jui.Component({
      attributes: {
        className: 'details modal-left-panel'
      }
    });

    manager.insert(leftPanel);

    this.toolBar = leftPanel.insert(
      new jui.Component({
        attributes: {
          className: 'toolbar'
        }
      })
    );

    this.controls.addScript = this.toolBar.insert(
      new Element('a', {
        className: 'btn large green button'
      }).update('Add Script to this Variant')
    );
    this.controls.addScript.on('click', this.addScript.bind(this));

    this.scriptCollection = leftPanel.insert(
      new jui.Component({
        attributes: {
          className: 'script-collection'
        }
      })
    );

    var scriptsVariant = this.scriptCollection.insert(
      new jui.Component({
        attributes: {
          className: 'script-variant script-container'
        }
      })
    );

    var variantHeader = new Element('div', {
      className: 'variant-level-scripts-header scripts-header'
    }).update('VARIANT SCRIPTS');

    variantHeader.insert(
      new Element('span', {
        className: 'fa fa-angle-down scripts-header-icon'
      })
    );

    scriptsVariant.insert(variantHeader);

    this.details = manager.insert(
      new jui.Component({
        attributes: {
          className: 'details modal-right-panel'
        }
      })
    );

    this.list = scriptsVariant.insert(
      new jui.Component({
        attributes: {
          className: 'list variant-level-script-list'
        }
      })
    );

    this.predefinedList = leftPanel.insert(
      new jui.Component({
        attributes: {
          className: 'predefined'
        }
      })
    );

    this.predefinedList.insert(
      jQuery('<div class="scripts-header">SCRIPT LIBRARIES</div>')[0]
    );

    this.scriptDetailsView = this.details.insert(
      new jui.Component({
        attributes: {
          className: 'details code-info-view'
        }
      })
    );

    this.predefinedScriptDetailsView = this.details.insert(
      new jui.Component({
        attributes: {
          className: 'details predefined-code-info-view'
        }
      })
    );

    this.addPredefinedScriptsToEditor();

    this.uneditableMsg = new Element('div', {
      className: 'script-manager-message uneditable'
    }).hide();

    var scriptManagerButton = new Element('a', {
      href: '/' + editor.currentCompanyId + '/global_scripts/',
      className: 'btn small light button',
      target: '_blank'
    }).update('Open Script Manager');

    var scriptManagerText =
      '<a href="http://documentation.unbounce.com/hc/en-us/articles/' +
      '203879070-Using-Custom-JavaScript-and-CSS-on-Your-Landing-Page#content5" target="_blank">Script Manager <i class="fa fa-angle-double-right"></i></a>';

    //The following line isn't working
    this.uneditableMsg.insert(scriptManagerButton);
    //This line added instead
    this.uneditableMsg.insert(
      new Element('a', {
        href: '/' + editor.currentCompanyId + '/global_scripts/',
        className: 'btn small light button',
        target: '_blank'
      }).update('Open Script Manager')
    );
    this.uneditableMsg.insert(
      new Element('p').update(
        "<strong>Please Note:</strong> This script cannot be edited here as it is being used across this page's entire domain. If you want, you can make changes in the " +
          scriptManagerText
      )
    );

    this.controls.codeEditor = new jui.CodeEditor({
      label:
        'Paste or type scripts below. &lt;script&gt; tags must be included.'
    });

    // this.actions = this.contentPanel.insert( new jui.Component({attributes:{className:'actions clearfix'}}));
    this.warn = this.actionBar.insert(
      new Element('div', {
        className: 'warn'
      }).update('You must enter a valid script')
    );

    this.scriptManagerMsg = new Element('div', {
      className: 'script-manager-message'
    });

    this.scriptManagerMsg.insert(scriptManagerButton);

    this.scriptManagerMsg.insert(
      new Element('span', { className: 'svg-ico-education' })
    );

    this.scriptManagerMsg.insert(
      new Element('p').update(
        'Thinking of using this script on more than just this page? You can add it to an entire domain using ' +
          scriptManagerText
      )
    );

    this.controls.predefinedDescription = new Element('p', {
      className: 'predefined-desciption'
    });
    this.controls.predefinedTitle = new Element('h2', {
      className: 'predefined-title'
    });

    this._createScriptControls(updateView);
    this._createUneditableScriptControls();

    this.scriptDetailsView.insert(this.controls.controlContainer[0]);
    this.scriptDetailsView.insert(this.controls.uneditableControlsContainer[0]);
    this.scriptDetailsView.insert(this.controls.codeEditor);
    this.scriptDetailsView.insert(this.uneditableMsg);

    if (window.editor.mainPage.getConfigValue('showScriptManager')) {
      this.scriptDetailsView.insert(this.scriptManagerMsg);
    }

    this.predefinedScriptDetailsView.insert(this.controls.predefinedTitle);
    this.predefinedScriptDetailsView.insert(
      this.controls.predefinedDescription
    );

    this.predefinedScriptDetailsView.setVisible(false);
    this.warn.hide();
  },

  _createScriptControls: function(updateView) {
    this.controls.scriptName = new jui.FormTextInput({
      label: 'Script Name',
      width: '220px',
      onkeyup: updateView
    });

    this.controls.placement = new jui.FormSelect({
      label: 'Placement',
      id: 'jui-script-place-select',
      dropDownClassName: 'modal-select2-dropdown jui-drop-down',
      width: '220px',
      selectOptions: [
        {
          name: 'Before Body End Tag',
          value: 'body:after'
        },
        {
          name: 'After Body Tag',
          value: 'body:before'
        },
        {
          name: 'Head',
          value: 'head'
        }
      ],
      action: updateView
    });

    this.controls.controlContainer = jQuery(
      '<div class="script-controls"></div>'
    );
    this.controls.controlContainer.append(this.controls.scriptName.e);
    this.controls.controlContainer.append(this.controls.placement.e);
  },

  _createUneditableScriptControls: function() {
    this.controls.uneditableScriptNameSpan = new Element('span');
    this.controls.uneditableScriptName = new Element('div', {
      className: 'uneditable dummy-label label-name'
    });

    this.controls.uneditableScriptName.insert(
      new Element('label').update('Script Name')
    );
    this.controls.uneditableScriptName.insert(
      this.controls.uneditableScriptNameSpan
    );

    this.controls.uneditablePlacementSpan = new Element('span');
    this.controls.uneditablePlacement = new Element('div', {
      className: 'uneditable dummy-label label-placement'
    });

    this.controls.uneditablePlacement.insert(
      new Element('label').update('Placement')
    );
    this.controls.uneditablePlacement.insert(
      this.controls.uneditablePlacementSpan
    );

    this.controls.uneditableControlsContainer = jQuery(
      '<div class="script-controls">'
    ).hide();
    this.controls.uneditableControlsContainer.append(
      this.controls.uneditableScriptName
    );
    this.controls.uneditableControlsContainer.append(
      this.controls.uneditablePlacement
    );
  },

  isJQueryInPage: function() {
    var self = this;
    var isJQueryInPage = false;
    var jqueryList = this.predefinedOptionalScripts.findAll(function(s) {
      return s.group === 'jquery';
    });

    var page = editor.page;
    jqueryList.each(function(s) {
      if (self.isPredefinedScriptInPage(page, s.name)) {
        isJQueryInPage = true;
        return true;
      }
    });
    return isJQueryInPage;
  },

  isPredefinedScriptInPage: function(page, scriptName) {
    var scripts = page.getElementsByType('lp-script');
    var isFound = scripts.find(function(s) {
      return s.name === scriptName && this.isScriptPredefined(s);
    }, this);
    return typeof isFound !== 'undefined';
  },

  createPredefinedOptionalScripts: function(page, checkedScript) {
    var script = this.getModule().buildPageElement(
      page,
      jui.clone(checkedScript)
    );
    var scripts = page.getElementsByType('lp-script');

    var hasScript = scripts.detect(function(s) {
      return this.isNamedScriptPredefined(s, script.name);
    }, this);

    //Make sure that a script does not get inserted into the page
    //more then once.
    if (hasScript) {
      return hasScript;
    }

    page.undoManager.startGroup();

    var index = this.getInsertIndex(page, script, scripts);
    page.insertElement(script, {
      silent: true,
      index: index
    });

    this.selectDependants(page, script);
    page.undoManager.endGroup();

    this.warn.hide();
    return script;
  },

  selectDependants: function(page, script) {
    if (this.isPredefinedScriptInPage(page, script.name)) {
      this.controls[script.name].checkbox.checked = true;
      this.handlePredefinedScriptDependencies(page, script);
    }
  },

  handlePredefinedScriptDependencies: function(page, script) {
    //Recursive! Be careful.
    if (script.model.exists('requires')) {
      var requires = script.model.get('requires').split(',');
      requires.each(function(s) {
        s = s.trim();
        if (s === script.model.get('name')) {
          throw new Error(
            'The required script cannot be the same as the script which is trying to require it.'
          );
        }
        this.createPredefinedOptionalScripts(
          page,
          this.getPredefinedScriptByName(s)
        );
      }, this);
    }
  },

  getPredefinedScriptByName: function(name) {
    var script;
    this.predefinedOptionalScripts.each(function(s) {
      if (s.name === name) {
        script = s;
      }
    });
    return script;
  },

  getInsertIndex: function(page, script, scripts) {
    var predefinedScripts = this.getPredefinedScripts(scripts);
    var userScripts = this.getUserScripts(scripts);
    var index = page.indexOfElement(predefinedScripts.last());
    var indexChanged = false;

    predefinedScripts.each(function(s) {
      if (script.model.get('index') < s.model.get('index')) {
        index = page.indexOfElement(s);
        indexChanged = true;
      }
    });

    if (!indexChanged) {
      if (userScripts.size() !== 0) {
        index = page.indexOfElement(userScripts.first());
      } else {
        index++;
      }
    }
    return index;
  },

  getPredefinedScripts: function(scripts) {
    return scripts.findAll(function(s) {
      return this.isScriptPredefined(s);
    }, this);
  },

  getUserScripts: function(scripts) {
    return scripts.findAll(function(s) {
      return !this.isScriptPredefined(s);
    }, this);
  },

  removePredinedOptionScripts: function(page, script) {
    var scripts = page.getElementsByType('lp-script');
    var scriptToRemove = scripts.detect(function(s) {
      return this.isNamedScriptPredefined(s, script.name);
    }, this);

    if (this.hasDependents(page, script, scripts)) {
      this.deslectDependants(page, script, scripts);
    }

    if (scriptToRemove) {
      this.removeScript(scriptToRemove);
    }
  },

  deslectDependants: function(page, script, scripts) {
    var dependents = this.getDependents(page, script, scripts);
    var self = this;
    dependents.each(function(s) {
      self.removePredinedOptionScripts(page, s);
      self.controls[s.name].checkbox.checked = false;
    });
  },

  hasDependents: function(page, script, scripts) {
    var predefinedScripts = this.getPredefinedScripts(scripts);
    var dependent = false;
    var scriptName = script.name;
    predefinedScripts.each(function(s) {
      if (s.model.exists('requires')) {
        var requires = s.model.get('requires').split(',');
        var found = requires.find(function(s) {
          return s.trim() === scriptName;
        });
        dependent = typeof found === 'undefined' ? false : true;
      }
    });
    return dependent;
  },

  getDependents: function(page, script, scripts) {
    var predefinedScripts = this.getPredefinedScripts(scripts);
    var scriptName = script.name;
    var dependants = predefinedScripts.findAll(function(s) {
      if (s.model.exists('requires')) {
        var requires = s.model.get('requires').split(',');
        var found = requires.find(function(s) {
          return s.trim() === scriptName;
        });
        return found;
      }
    });
    return dependants;
  },

  isNamedScriptPredefined: function(script, name) {
    return this.isScriptPredefined(script) && script.model.get('name') === name;
  },

  isScriptPredefined: function(script) {
    return (
      script.predefined ||
      (script.model.exists('predefined') && script.model.get('predefined'))
    );
  },

  updateList: function(keepUnselected, elm) {
    /* jshint unused:vars */

    this.selectedScript = null;
    this.currentScripts = window.editor.page
      .getElementsByType('lp-script')
      .clone();

    this.list.clear();
    var scripts = this.currentScripts.concat(this.newScripts);

    //Make user predefined scripts are not included in the list.
    scripts = this.getNonPredefinedScripts(scripts);
    if (scripts.length === 0) {
      //|| !elm
      this.addScript();
      return;
    }

    this.addUserScriptListItems(scripts);
    this.selectScript(scripts.last());
  },

  getNonPredefinedScripts: function(scripts) {
    return scripts
      .collect(function(script) {
        if (!script.model.exists('predefined')) {
          return script;
        }
      })
      .compact();
  },

  addUserScriptListItems: function(scripts) {
    var ul = this.list.insert(new Element('ul'));
    var self = this;

    scripts.each(function(s) {
      var removeButton = new Element('a', {
        className: 'remove-button',
        href: '#'
      }).update('✕');
      removeButton = new Element('a', {
        className: 'remove-button svg-ico-delete',
        href: '#'
      });

      removeButton.on('click', function() {
        self.removeSpecificScript(s);
      });

      var li = new Element('li', {
        id: 'item-' + s.id
      })
        .insert(
          new Element('div', { className: 'script-label' }).insert(
            new Element('a', {
              href: '#'
            })
              .update(s.model.get('name'))
              .observe('click', this.scriptClicked.bind(this, s))
          )
        )
        .insert(removeButton);

      ul.insert(li);
    }, this);
  },

  addPredefinedScriptsToEditor: function() {
    var self = this;
    var list = new Element('ul');
    this.predefinedList.insert(list);
    this.predefinedOptionalScripts.each(function(script) {
      var listItem = new Element('li', { id: 'item-' + script.listId });
      var cbx = new jui.FormCheckboxInput({
        label: script.name,
        classNames: ['predefined-scripts', 'predefined-scripts-' + script.name],
        onclick: function(e) {
          self.predefinedScriptCheckboxClicked(e, script);
        },
        checked: this.isPredefinedScriptInPage(editor.page, script.name)
      });

      cbx.label.observe(
        'click',
        this.predefinedScriptClicked.bind(this, script)
      );

      this.controls[script.name] = cbx;
      listItem.insert(cbx.e);

      list.insert(listItem);
    }, this);
  },

  showScriptDetails: function(script) {
    this.predefinedScriptDetailsView.setVisible(false);
    this.scriptDetailsView.setVisible(true);

    this.controls.scriptName.setValue(script.model.get('name'));
    this.controls.uneditableScriptNameSpan.update(
      _.escape(script.model.get('name'))
    );

    this.controls.uneditablePlacementSpan.update(
      this.mapNamedPosition(script.model.get('placement'))
    );

    this.controls.placement.setSelectedValue(script.model.get('placement'));
    this.controls.codeEditor.setValue(script.model.get('content.html'));
  },

  showPredefinedScriptDetails: function(script) {
    this.scriptDetailsView.setVisible(false);
    this.predefinedScriptDetailsView.setVisible(true);

    this.controls.predefinedTitle.update(script.name);
    this.controls.predefinedDescription.update(script.description);
    this.controls.scriptName.setValue(script.name);
    this.controls.placement.setSelectedValue(script.placement);
  },

  scriptClicked: function(script) {
    if (script === this.selectedScript) {
      return;
    }

    this.changeEditState(script);
    this.updateSelectedScript();

    if (this.selectedScript && !this.scriptHasContent(this.selectedScript)) {
      this.removeScript(this.selectedScript);
    }
    this.selectScript(script);
  },

  predefinedScriptClicked: function(script) {
    if (script === this.selectedPredefinedScript) {
      return;
    }

    this.updateSelectedScript();
    if (this.selectedScript && !this.scriptHasContent(this.selectedScript)) {
      this.removeScript(this.selectedScript);
    }
    this.selectPredefinedScript(script);
  },

  predefinedScriptCheckboxClicked: function(e, script) {
    this.warn.hide();
    if (e.data) {
      this.createPredefinedOptionalScripts(window.editor.page, script);
    } else {
      this.removePredinedOptionScripts(editor.page, script);
    }
  },

  deselectAllScripts: function() {
    this.deselectSelectedScript();
    this.deselectSelectedPredefinedScript();
  },

  deselectSelectedScript: function() {
    if (this.selectedScript !== null) {
      jQuery('.scripts-manager .list li').removeClass('active');
      if (!this.scriptHasContent(this.selectedScript)) {
        this.removeScript(this.selectedScript);
      }
    }

    this.selectedScript = null;
  },

  deselectSelectedPredefinedScript: function() {
    if (this.selectedPredefinedScript !== null) {
      this.predefinedList.e
        .down('li#item-' + this.selectedPredefinedScript.listId)
        .removeClassName('active');
    }

    this.selectedPredefinedScript = null;
  },

  selectScript: function(script) {
    this.deselectAllScripts();
    this.showScriptDetails(script);
    jQuery('.scripts-manager li#item-' + script.id).addClass('active');
    this.selectedScript = script;
    var editor = this.controls.codeEditor;
    var valid = script.model.exists('content.valid') ? script.model.get('content.valid') : true;
    editor.showHTMLWarningIfInvalid(this, this.closeIfValid, valid);
  },

  selectPredefinedScript: function(script) {
    this.deselectAllScripts();
    this.showPredefinedScriptDetails(script);
    this.predefinedList.e
      .down('li#item-' + script.listId)
      .addClassName('active');
    this.selectedPredefinedScript = script;
  },

  createNewScript: function() {
    var module = this.getModule();
    return module.buildPageElement(window.editor.page, {
      name: window.editor.page.generateDefaultElementName(
        module.type,
        module.defaultName
      ),
      containerId: null,
      placement: 'body:after',
      content: {
        type: null,
        html: ''
      }
    });
  },

  addScript: function() {
    this.updateSelectedScript();

    if (
      this.newScripts.length === 1 ||
      (this.selectedScript !== null &&
        !this.scriptHasContent(this.selectedScript))
    ) {
      return;
    }

    var newScript = this.createNewScript();

    this.deselectSelectedScript();
    this.changeEditState(newScript);
    this.newScripts.push(newScript);
    this.selectedScript = null;
    this.updateList();
    this.list.e.down('ul').scrollTop = this.list.e.down('ul').scrollHeight;

    return newScript;
  },

  removeScript: function(script) {
    window.editor.page.undoManager.startGroup();
    script.removeFromPage();
    window.editor.page.undoManager.endGroup();
  },

  removeSelectedScript: function() {
    if (this.selectedScript === null) {
      return;
    }

    if (this.currentScripts.indexOf(this.selectedScript) > -1) {
      this.removeScript(this.selectedScript);
    } else {
      this.newScripts = this.newScripts.without(this.selectedScript);
    }

    this.selectedScript = null;
    this.updateList(false);
  },

  removeSpecificScript: function(script) {
    if (this.currentScripts.indexOf(script) > -1) {
      this.removeScript(script);
    } else {
      this.newScripts = this.newScripts.without(script);
    }
    this.updateList(false);
  },

  scriptHasContent: function(script) {
    return script !== null && script.model.get('content.html') !== '';
  },

  updateSelectedScript: function() {
    var s = this.selectedScript;

    if (s === null || s.domainLevel === true) {
      return;
    }

    var isNew = this.currentScripts.indexOf(s) === -1;
    var um = isNew ? null : window.editor.activeUndoManager;

    var change =
      s.model.get('content.html') !== this.controls.codeEditor.getValue() ||
      s.model.get('placement') !== this.controls.placement.getValue() ||
      s.model.get('name') !== this.controls.scriptName.getValue();

    if (!isNew && change) {
      this.startUndoGroup();
    }

    if (change) {
      s.model.set('name', this.getName(), um);
      s.model.set('placement', this.controls.placement.getValue(), um);
      s.model.set('content.html', this.controls.codeEditor.getValue(), um);
      s.model.set('content.valid', this.controls.codeEditor.isValid(), um);
      s.model.set('content.errors', this.controls.codeEditor.getErrors(), um);
    }

    if (isNew) {
      if (this.scriptHasContent(s)) {
        this.startUndoGroup();
        window.editor.page.insertElement(s);
        // window.editor.page.insertElement(s, {silent:true});
        this.newScripts = [];
        this.updateList(false);
      } else {
        var newScript = this.newScripts.without(s);
        //This check is nessary because if we are here and their are no new
        //scripts, it is because we are clicking on a predefined script
        //before actually adding a user script.
        if (newScript.length > 0) {
          this.newScripts = newScript;
        }
      }
    } else {
      //Updates the drawer with warning if needed.
      window.editor.page.updateElement(s);
    }
  },

  getName: function() {
    return _.escape(this.controls.scriptName.getValue());
  },

  updateView: function() {
    var listItem = this.list.e.down('li#item-' + this.selectedScript.id + ' a');
    listItem.update(this.getName().truncate(25));
  },

  requestFocus: function() {
    window.editor.keyController.requestFocus(this);
  },

  startUndoGroup: function() {
    if (this.undoGroupStarted) {
      return;
    }
    this.undoGroupStarted = true;
    window.editor.activeUndoManager.startGroup();
  },

  cancel: function() {
    this.closeIfValid();
  },

  done: function() {
    this.closeIfValid();
  },

  open: function($super, elm, options) {
    $super();

    this.clearDomainLevelScripts();

    if (options && options.callback) {
      this.options.callback = options.callback;
    }
    this.requestFocus();

    var usedAsText = window.editor.page.getUsedAsText();
    var headerTitleText = 'Manage Scripts on ' + usedAsText;

    if (window.editor.page.usedAs() === 'main') {
      headerTitleText = 'Manage Scripts';
    }

    this.setTitle(headerTitleText);
    this.newScripts = [];
    this.currentScripts = [];
    this.selectedScript = null;

    // BUG. What is the expected behaviour here?? newScript is never used
    var newScript = elm || this.addScript();
    this.newScript = newScript;

    if (window.editor.mainPage.getConfigValue('showScriptManager')) {
      this.fetchDomainLevelScripts();
    }

    if (elm) {
      this.updateList(false);
      this.selectScript(elm);
      var model = elm.model;
      var valid = model.exists('content.valid') ? model.get('content.valid') : true;
      var closeFunction = this.closeIfValid;
      this.controls.codeEditor.showHTMLWarningIfInvalid(
        this,
        closeFunction,
        valid
      );
    } else {
      this.addScript();
    }
  },

  closeIfValid: function() {
    this.controls.codeEditor.isValidContentHTML(this, this.forceClose);
  },

  forceClose: function(force) {
    if (!!force) {
      this.updateSelectedScript();
      if (this.undoGroupStarted) {
        window.editor.activeUndoManager.endGroup();
        this.undoGroupStarted = false;
        if (typeof eventTracker !== 'undefined') {
          eventTracker.track('Add Javascript', 'Editor');
        }
      }
      this.close();
    }
  },

  clearDomainLevelScripts: function() {
    jQuery('.domain-level-scripts-header').remove();
    jQuery('.domain-level-script-list').remove();
  },

  addDomainLevelScripts: function(scripts) {
    var $scriptsDomain =
      jQuery('.script-domain.script-container').length > 0 ? jQuery('.script-domain.script-container') : jQuery(new jui.Component({attributes: { className: 'script-domain script-container' }}).e);

    jQuery(this.scriptCollection.e).prepend($scriptsDomain);

    var $domainHeader = jQuery('<div>DOMAIN SCRIPTS</div>').addClass(
      'domain-level-scripts-header scripts-header'
    );

    $domainHeader.append(
      jQuery('<span></span>').addClass('fa fa-angle-down scripts-header-icon')
    );

    $scriptsDomain.append($domainHeader);

    var $domainListContainer = jQuery('<div>').addClass(
      'list domain-level-script-list'
    );

    $domainHeader.after($domainListContainer);

    var $scriptList = jQuery('<ul>');
    $domainListContainer.append($scriptList);

    var scriptBind = function(script) {
      var $link = jQuery('<a href="#">').text(script.name);
      var $linkContainer = jQuery('<div class="script-label">');
      var $scriptItem = jQuery("<li id='item-" + script.id + "'>");
      $linkContainer.append($link);
      $scriptItem.append($linkContainer);
      $scriptList.append($scriptItem);

      $link
        .text(script.model.get('name'))
        .click(this.scriptClicked.bind(this, script));
      return $scriptItem;
    };

    // TODO: this is never used
    var scriptListContents = _.map(scripts, scriptBind.bind(this));
    this.scriptListContents = scriptListContents;
  },

  changeEditState: function(script) {
    if (script.domainLevel) {
      this.changeScriptLink(script.id);
      this.showUneditableAttributes();
    } else {
      this.showDefaultAttributes();
    }
  },

  changeScriptLink: function(script_uuid) {
    var url = '/' + editor.currentCompanyId + '/global_scripts/' + script_uuid;
    jQuery('.script-manager-message.uneditable a').attr('href', url);
  },

  showUneditableAttributes: function() {
    document.getElementById('script-manager').className =
      'scripts-manager domain-scripts-view';
    this.controls.controlContainer.hide();
    this.controls.uneditableControlsContainer.show();
    this.controls.codeEditor.codeMirror.setOption('readOnly', 'nocursor');
    this.scriptManagerMsg.hide();
    this.uneditableMsg.show();
  },

  showDefaultAttributes: function() {
    document.getElementById('script-manager').className = 'scripts-manager';
    this.controls.controlContainer.show();
    this.controls.uneditableControlsContainer.hide();
    this.controls.codeEditor.codeMirror.setOption('readOnly', false);
    this.scriptManagerMsg.show();
    this.uneditableMsg.hide();
  },

  // Marshall script to match variant level objects
  marshallDomainScript: function(originalScript) {
    var script = originalScript;
    script['content.html'] = script.data;
    script.placement = this.mapPosition(script.position);
    script.model = new Hash(script);
    script.model.exists = function() {
      return true;
    };
    script.domainLevel = true;
    return script;
  },

  // Filter based on the active page
  filterTargetFor: function(target, scripts) {
    return scripts.filter(function(script) {
      var validTarget =
        target === 'form_confirmation' ? 'confirmation' : target;
      return script.target === 'all' || script.target === validTarget;
    });
  },

  fetchDomainLevelScripts: function() {
    var domain = url.parse(editor.mainPage.page.published_url).host;
    var requestUrl =
      '/' + editor.currentCompanyId + '/global_scripts/?domain=' + domain;
    var self = this;

    jQuery.getJSON(requestUrl, {}, function(data) {
      var scripts = data.map(function(s) {
        return self.marshallDomainScript(s.global_script);
      });
      scripts = self.filterTargetFor(editor.page.usedAs(), scripts);

      if (scripts.length !== 0) {
        self.addDomainLevelScripts(scripts);
      }
    });
  },

  mapPosition: function(position) {
    switch (position) {
      case 'afterBodyStart':
        return 'body:before';
      case 'beforeBodyEnd':
        return 'body:after';
      case 'beforeHeadEnd':
        return 'head';
    }
  },

  mapNamedPosition: function(position) {
    switch (position) {
      case 'body:before':
        return 'After Body Tag';
      case 'body:after':
        return 'Before Body End Tag';
      case 'head':
        return 'Head';
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-script/script_element_builder.js
// module id = 1475
// module chunks = 0